module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_store_access_mail-6daf0396213cea106b82fb9d17e0a95b.svg";